<template>
  <div class="sliders" v-if="sliders.length">
    <VueSlickCarousel v-bind="settings" :focusOnSelect="true">
      <template>
        <div class="slick-item"  v-for="slider in sliders" :key="slider.id">
          <img :src="getIconUrl(slider)" alt="" />
        </div>
      </template>
    </VueSlickCarousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");

export default {
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      settings: {
        arrows: false,
        dots: true,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 6000,
        autoplaySpeed: 6000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
            },
          },          
        ],
      },
    };
  },
  created() {
  },
  mounted() {
    this.getSliders();
  },
  methods: {
    getIconUrl(slider) {
      return slider.icon
        ? `${slider.base_url}${slider.icon.url}`
        : '@/assets/icons/category_default.png';
    },

    ...mapActions(["getSliders"]),
  },
  computed: {
    ...mapState(["sliders"]),
  },
};
</script>

<style lang="scss" scoped>
.sliders {
  margin-bottom: 30px;
}

.slick-item {
    img {
      width: 100%;
      height: 380px;
      object-fit: cover;
      margin: 5px 0px;
    }
}

@media screen and (max-width: 768px) and (min-width: 481px) {
  .slick-item {
    img {
      width: 100%;
      height: 340px;
      object-fit: cover;
      margin: 5px 0px;
    }
  } 
}

@media screen and (max-width: 480px) and (min-width: 0) {
  .slick-item {
    img {
      width: 100%;
      height: 300px;
      object-fit: cover;
      margin: 5px 0px;
    }
  } 
}

</style>
